<script>
    import R, {LOADER} from "../lib/requests";
    import app from "../stores/app";
    import user from "../stores/user";
    import {clickOutside} from "../lib/clickOutside";
    import {createEventDispatcher} from 'svelte/internal';
    import SampleAnalyses from "./SampleAnalyses.svelte";
    import CodeControl from "../components/controls/CodeControl.svelte";
    import Checkbox from "../components/controls/Checkbox.svelte";
    import SelectControl from "../components/controls/SelectControl.svelte";
    import SampleTypeSelectControl from "../components/controls/SampleTypeSelectControl.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import TimeControl from "../components/controls/TimeControl.svelte";
    // import SamplingFromControl from "../components/controls/SamplingFromControl.svelte";
    // import AutoCompleteInputControl from "../components/controls/AutoCompleteInputControl.svelte";

    export let sample = null;
    export let clientId = null;
    export let allowOnCloud = false;
    export let analysesGroups;
    export let singleEdit = false; // if true sample is edited through /samples/SampleEdit component

    let lockTitle = '';
    // let showPrint = false;
    let showPrintSettings = false;
    let showCloneDropdown = false;

    const statuses = [
        'ΚΑΝΟΝΙΚΗ',
        'NORMAL'
    ];

    const dispatch = createEventDispatcher();

    const toggleView = () => {
        if (!singleEdit) {
            sample.is_collapsed = sample.is_collapsed == 1 ? 0 : 1;
        }
    }

    const toggleLock = () => {
        sample.is_locked = sample.is_locked == 1 ? 0 : 1;
        if (sample.is_locked == 0) {
            sample.is_collapsed = 0;
        }
    }

    const toggleCloud = () => {
        const onSuccess = result => {
            sample.is_on_cloud = result;
            Notifier.showMessage(result === 1 ? "Ο πελάτης μπορεί να εκτυπώσει το δείγμα" : "Το δείγμα δεν είναι διαθέσιμο στον πελάτη");
        }

        const onFailure = err => {
        };

        R.handle(R.sample.toggleCloud, {
            id: sample.id,
            is_on_cloud: sample.is_on_cloud == 1 ? 0 : 1
        }, onSuccess, onFailure, LOADER.POPUP);
    }

    const togglePrintSettings = () => {
        showPrintSettings = !showPrintSettings;
        if (showPrintSettings && !sample.print_rows) {
            sample.print_rows = [null, null];
        }
        if (!showPrintSettings) {
            if (!sample.print_rows[0]) {
                sample.print_rows[0] = null;
            }
            if (!sample.print_rows[1]) {
                sample.print_rows[1] = null;
            }
        }
    }

    const toggleCloneDropdown = () => {
        showCloneDropdown = !showCloneDropdown;
    }

    const onChange = () => {
        dispatch("change");
        sample.isDirty = true;
    }

    const onClone = () => {
        showCloneDropdown = false;
        dispatch("clone", sample);
    }

    const onCopy = () => {
        showCloneDropdown = false;
        dispatch("copy", sample);
    }

    const onDelete = () => {
        dispatch("delete", sample);
    }

    const onPrint = () => {
        if (sample.isDirty) {
            Alert.confirm("Εκτύπωση δείγματος", "Το δείγμα έχει υποστεί αλλαγές που δεν έχετε αποθηκεύσει.\nΑυτές οι αλλαγές δεν θα εμφανιστούν στο έγγραφο.\nΘέλετε να συνεχίσετε;",
                () => {
                    dispatch("print", sample);
                }
            );
            return;
        }
        dispatch("print", sample);
    }

    $: {
        lockTitle = sample.is_locked == 1 ? "ξεκλείδωμα των στοιχείων του δείγματος" : "κλείδωμα των στοιχείων του δείγματος";
    }
</script>

{#if sample}
    <div class="panel panel-default mb-4">
        <div class="panel-heading darker py-2">
            <div class="d-flex align-items-center fw-semibold pointer" on:click={ toggleView }>
                {#if !singleEdit}
                    <div class="sample-toggle-icon" class:expanded={ sample.is_collapsed == 0 }>
                        <AppIcon icon="chevron-right" strokeWidth="2" size="18"/>
                    </div>
                {/if}
                {#if sample.is_on_cloud == 1}
                    <div class="cloud-icon">
                        <AppIcon icon="cloud"/>
                    </div>
                {/if}
                Στοιχεία Δείγματος
            </div>
            <div class="d-flex align-items-center">
                <button class="btn btn-outline btn-sm" title="{ lockTitle }" on:click={ toggleLock }>
                    {#if sample.is_locked == 1}
                        <AppIcon icon="lock"/>
                    {:else}
                        <AppIcon icon="lock-open"/>
                    {/if}
                </button>
                {#if !singleEdit}
                    <div class="dropdown">
                        <button class="btn btn-outline btn-sm ms-1" title="δημιουργία δείγματος"
                                on:click={toggleCloneDropdown}>
                            <AppIcon icon="clone"/>
                        </button>
                        {#if showCloneDropdown}
                            <ul class="dropdown-menu show clone-dropdown" use:clickOutside
                                on:click_outside={() => showCloneDropdown = false}>
                                <li>
                                    <button class="dropdown-item" on:click={onClone}>Δείγμα με ίδια στοιχεία</button>
                                </li>
                                <li>
                                    <button class="dropdown-item" on:click={onCopy}>Δείγμα μόνο με αναλύσεις</button>
                                </li>
                            </ul>
                        {/if}
                    </div>
                {/if}
                {#if sample.id > 0}
                    <button class="btn btn-outline btn-sm ms-1" title="εκτύπωση δείγματος" on:click={ onPrint }>
                        <AppIcon icon="print"/>
                    </button>
                {/if}
                {#if allowOnCloud}
                    {#if sample.is_on_cloud == 1}
                        <button class="btn btn-primary btn-sm ms-1" title="ο πελάτης μπορεί να το εκτυπώσει"
                                on:click={toggleCloud} disabled={sample.id == 0}>
                            <AppIcon icon="client"/>
                        </button>
                    {:else}
                        <button class="btn btn-outline btn-sm ms-1" title="μη διαθέσιμο στον πελάτη"
                                on:click={toggleCloud}>
                            <AppIcon icon="client-not"/>
                        </button>
                    {/if}
                {/if}
                <div class="dropdown-container ms-1">
                    <button class="btn btn-outline btn-sm" title="ρυθμίσεις εκτύπωσης δείγματος"
                            on:click={togglePrintSettings}>
                        <AppIcon icon="gear-solid"/>
                    </button>
                    {#if showPrintSettings}
                        <div class="dropdown right p-3" use:clickOutside on:click_outside={togglePrintSettings}>
                            <div class="text-gray mb-1">
                                Αριθμός αναλύσεων / σελίδα<br>εκτύπωσης του δείγματος
                            </div>
                            <div class="row">
                                <div class="col-6" style="max-width: 120px;">
                                    <label class="label-sm text-truncate">Πρώτη σελίδα</label>
                                    <input type="number" class="form-control" min="0" max="12"
                                           bind:value={sample.print_rows[0]} on:change={onChange}
                                           placeholder="12">
                                </div>
                                <div class="col-6" style="max-width: 120px;">
                                    <label class="label-sm text-truncate">Υπόλοιπες σελίδες</label>
                                    <input type="number" class="form-control" min="0" max="22"
                                           bind:value={sample.print_rows[1]} on:change={onChange}
                                           placeholder="20">
                                </div>
                            </div>
                        </div>
                    {/if}
                </div>
                {#if user.isAdmin() && sample.id && !singleEdit}
                    <button class="btn btn-danger btn-sm ms-1" title="διαγραφή δείγματος" on:click={onDelete}>
                        <AppIcon icon="trash" strokeWidth="2"/>
                    </button>
                {/if}
            </div>
        </div>

        <div class="panel-body panel-pad pb-0">
            <div class="row">
                <div class="col-xl-1 col-lg-2 col-md-2 mb-2">
                    <label class="label-sm d-block text-truncate">Κωδ. δείγματος</label>
                    <CodeControl id="sampleCode-{ sample.index }" bind:value="{ sample.code }"
                                 on:change={ onChange } disabled="{ sample.is_locked }"/>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-4 mb-2">
                    <label class="label-sm">Είδος δείγματος</label>
                    <SampleTypeSelectControl clientId="{ clientId }" bind:value="{ sample.type }"
                                             on:change={ onChange } disabled="{ sample.is_locked }"/>
                </div>
                <div class="col-xl-4 col-lg-6 col-md-6 mb-2">
                    <label class="label-sm">Χαρακτηρισμός</label>
                    <input type="text" class="form-control" bind:value="{ sample.characterization }"
                           on:change={ onChange } disabled="{ sample.is_locked }">
                </div>
                <div class="col-xl-2 col-lg-6 col-md-6 mb-2">
                    <label class="label-sm">Κατάσταση δείγματος</label>
                    <SelectControl bind:value={sample.status} values={statuses}
                                   on:change={onChange} disabled={sample.is_locked}/>
                </div>
                <div class="col-xl-2 col-md-4 mb-2">
                    <label class="label-sm">Δειγματοληψία από</label>
                    <!--                    <SamplingFromControl bind:value={sample.sampling_from} on:change={ onChange }-->
                    <!--                                         disabled={sample.is_locked}/>-->
                    <SelectControl bind:value={sample.sampling_from} values={$app.sampling_from}
                                   on:change={onChange} disabled={sample.is_locked}/>
                </div>
                <div class="col-xl-1 col-md-2 mb-2">
                    <label class="label-sm">Έκδοση</label>
                    <input type="number" class="form-control" bind:value="{ sample.edition }" on:change={ onChange }
                           disabled="{ sample.is_locked }">
                </div>
            </div>

            {#if !sample.is_collapsed}
                <div class="row">
                    <div class="col-xl-2 col-md-6 mb-2">
                        <label class="label-sm">Αρ. αναφοράς</label>
                        <input type="text" class="form-control" bind:value="{ sample.reference_no }"
                               on:change={ onChange } disabled="{ sample.is_locked }">
                    </div>
                    <div class="col-xl-3 col-md-6 mb-2">
                        <label class="label-sm">Μέθοδος δειγματοληψίας</label>
                        <SelectControl bind:value={sample.sampling_method} values={$app.sampling_method}
                                       on:change={onChange} disabled={sample.is_locked}/>
                    </div>
                    <div class="col-xl-6 mb-2">
                        <label class="label-sm">Σημείο δειγματοληψίας</label>
                        <input type="text" class="form-control" bind:value="{ sample.location }"
                               on:change={ onChange } disabled="{ sample.is_locked }">
                    </div>
                    <div class="col-xl-1 col-lg-3 mb-2">
                        <label class="label-sm" title="Θερμοκρασία δείγματος κατά την παραλαβή (°C)">
                            Θερμοκ. (°C)
                        </label>
                        <input type="text" class="form-control" bind:value="{ sample.temperature }"
                               on:change={ onChange } disabled="{ sample.is_locked }">
                    </div>
                    <div class="col-xl-2 col-lg-4 mb-2">
                        <label class="label-sm">Συνθήκες μεταφοράς</label>
                        <select class="form-select" bind:value="{ sample.carriage_conditions }"
                                on:change={ onChange } disabled="{ sample.is_locked }">
                            <option value=""></option>
                            <option value="ΠΕΡΙΒΑΛΛΟΝ">ΠΕΡΙΒΑΛΛΟΝ</option>
                            <option value="ΙΣΟΘΕΡΜΙΚΟΣ ΘΑΛΑΜΟΣ">ΙΣΟΘΕΡΜΙΚΟΣ ΘΑΛΑΜΟΣ</option>
                            <option value="ENVIRONMENT">ENVIRONMENT</option>
                            <option value="ISOTHERMAL BOX">ISOTHERMAL BOX</option>
                        </select>
                    </div>
                    <div class="col-xl-3 col-lg-5 mb-2">
                        <label class="label-sm">Συσκευασία</label>
                        <SelectControl bind:value="{ sample.package }" values={$app.sample_packages}
                                       on:change={ onChange } disabled="{ sample.is_locked }"/>
                    </div>
                    <div class="col-xl-2 mb-2">
                        <label class="label-sm">Θέση</label>
                        <input type="text" class="form-control" bind:value={sample.position}
                               on:change={onChange} disabled={sample.is_locked}>
                    </div>
                    <div class="col-xl-5 mb-2">
                        <label class="label-sm">Μήτρα</label>
                        <input type="text" class="form-control" bind:value={sample.matrix}
                               on:change={onChange} disabled={sample.is_locked}>
                    </div>
                    <div class="col-xl-2 col-md-3 d-flex gap-2 mb-2">
                        <div>
                            <label class="label-sm">Ημερομηνία παραλαβής</label>
                            <input type="date" class="form-control" bind:value={sample.delivered_at}
                                   on:change={onChange} disabled={sample.is_locked}>
                        </div>
                        <div>
                            <label class="label-sm">Ώρα</label>
                            <TimeControl bind:value={sample.delivered_time} on:change={onChange}
                                         disabled={sample.is_locked}/>
                        </div>
                    </div>
                    <div class="col-xl-2 col-md-3 d-flex gap-2 mb-2">
                        <div>
                            <label class="label-sm">Έναρξη ανάλυσης</label>
                            <input type="date" class="form-control" bind:value={sample.analysis_start_at}
                                   on:change={onChange} disabled={sample.is_locked}>
                        </div>
                        <div class="mb-2">
                            <label class="label-sm">Ώρα</label>
                            <TimeControl bind:value={sample.analysis_start_time} on:change={onChange}
                                         disabled={sample.is_locked}/>
                        </div>
                    </div>
                    <div class="col-xl-2 col-md-3 d-flex gap-2 mb-2">
                        <div>
                            <label class="label-sm">Λήξη ανάλυσης</label>
                            <input type="date" class="form-control" bind:value={sample.analysis_end_at}
                                   on:change={onChange} disabled={sample.is_locked}>
                        </div>
                        <div class="mb-2">
                            <label class="label-sm">Ώρα</label>
                            <TimeControl bind:value={sample.analysis_end_time} on:change={onChange}
                                         disabled={sample.is_locked}/>
                        </div>
                    </div>
                    <!--                    <div class="col-xl-2 col-md-3 mb-2">-->
                    <!--                        <label class="label-sm d-block text-truncate"-->
                    <!--                               title="Διάστημα μεταξύ δειγματοληψίας και έναρξη ανάλυσης">-->
                    <!--                            Διάστημα δειγμ./ανάλυσης-->
                    <!--                        </label>-->
                    <!--                        <input type="text" class="form-control" bind:value="{ sample.analysis_interval }"-->
                    <!--                               on:change={ onChange } disabled="{ sample.is_locked }">-->
                    <!--                    </div>-->

                    <div class="col-xl-2 col-md-3 mb-2">
                        <label class="label-sm">Αναλυτές</label>
                        <input type="text" class="form-control" bind:value={sample.analysts}
                               on:change={ onChange } disabled={sample.is_locked}>
                    </div>

                    <div class="col-xl-1 col-md-3 col-6 d-flex align-items-center">
                        <Checkbox label="Αποδεκτό" bind:checked={sample.is_acceptable}
                                  on:change={onChange} disabled={sample.is_locked}/>
                    </div>
                    <div class="col-xl-1 col-md-3 col-6 d-flex align-items-center">
                        <Checkbox label="Έλεγχος" bind:checked={sample.is_checked}
                                  on:change={onChange} disabled={sample.is_locked}/>
                    </div>
                    <div class="col-xl-1 col-md-3 col-6 d-flex align-items-center">
                        <Checkbox label="Λογότυπο" bind:checked="{ sample.with_logo }"
                                  on:change={ onChange } disabled="{ sample.is_locked }"/>
                    </div>
                </div>
            {/if}
        </div>
        {#if !sample.is_collapsed}
            <SampleAnalyses bind:analyses={sample.analyses} {analysesGroups} isLocked="{ sample.is_locked }"
                            on:change={ onChange }
            />
        {/if}
    </div>
{/if}

<style>
    .cloud-icon {
        color: #919191;
        margin-right: 5px;
    }

    .sample-toggle-icon {
        padding: 5px;
        margin-left: -10px;
        transition: .3s all ease;
    }

    .sample-toggle-icon.expanded {
        transform: rotate(90deg);
    }

    .clone-dropdown {
        right: 0;
    }
</style>